import { render, staticRenderFns } from "./HorizontalScroller.vue?vue&type=template&id=363c87de&scoped=true"
import script from "./HorizontalScroller.vue?vue&type=script&lang=js"
export * from "./HorizontalScroller.vue?vue&type=script&lang=js"
import style0 from "./HorizontalScroller.vue?vue&type=style&index=0&id=363c87de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "363c87de",
  null
  
)

export default component.exports